<p-menubar class="p-menubar-primary" [model]="navItems" [autoDisplay]="false">
  <div class="app-logo">
    <img class="full-logo" (click)="getEolHomePage()" height="34" runat="server"
      src="assets/images/eurofins-logo-primary.png" alt="Eurofins logo" style="margin-top: 10px;">
    <app-page-header title="{{layout.pageHeader.pageTitle}}" icon="{{layout.pageHeader.pageIcon}}"
      iconLink="{{layout.pageHeader.iconLink}}" [(displayTemplate)]="displayTemplate">
    </app-page-header>
  </div>
</p-menubar>
